import React, { FC } from 'react';
import { Text } from 'components/_temp_ui_common/theme/Text';
import { Footer } from 'components/layout/FooterBar';

import {
  LeadContentFooterStyles,
  LeadFooterBackgroundColors,
  LeadFooterColors,
  LeadProgram,
  LeadProgramColor,
} from '../constants';

type FooterContentProps = React.HTMLAttributes<HTMLDivElement> & {
  program: LeadProgram;
};

export const FooterContent = ({
  program,
  children,
  ...props
}: React.PropsWithChildren<FooterContentProps>) => {
  return (
    <div
      {...props}
      className={`lg:p-4 py-4 flex flex-col text-center items-center lg:flex-row lg:justify-between lg:items-start lg:text-left ${props.className}`}
      style={{
        ...LeadContentFooterStyles[program],
        ...props.style,
      }}
    >
      {children}
    </div>
  );
};

interface LeadFooterProps {
  isDtc: boolean;
  program: LeadProgram;
}

const LeadFooter: FC<LeadFooterProps> = ({ isDtc, program }) => {
  const FooterLeftContent = (isDtc: boolean) => {
    return isDtc ? (
      <Text
        variant="body-7"
        className="mb-2 lg:mb-0 !inline"
        style={{
          color: LeadProgramColor[program],
        }}
      >
        Discover all of Bend Health’s services at{' '}
        <a
          href="https://bendhealth.com"
          target="_blank"
          rel="noreferrer"
          className="font-semibold cursor-pointer hover:underline !inline"
        >
          <Text variant="body-7" bold className="!inline">
            bendhealth.com
          </Text>
        </a>
      </Text>
    ) : (
      <Text variant="body-7">
        Refer to any of Bend Health&apos;s services at&nbsp;
        <Text variant="body-7" bold>
          <a
            href="https://bendhealth.com/refer"
            target="_blank"
            className="font-semibold cursor-pointer hover:underline"
            rel="noreferrer"
          >
            <Text bold variant="body-7" className="!inline">
              bendhealth.com
            </Text>
          </a>
        </Text>
      </Text>
    );
  };

  return (
    <Footer>
      <FooterContent program={program} style={{ color: LeadFooterBackgroundColors[program].text }}>
        {FooterLeftContent(isDtc)}
        <Text variant="body-7">© Bend Health Inc. All Rights Reserved</Text>
      </FooterContent>
    </Footer>
  );
};

export default LeadFooter;
